<input type="text" matInput [matAutocomplete]="auto" [(ngModel)]="value" (ngModelChange)="updateSearch()"/>
<mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectedAgency($event)">
  <mat-option *ngFor="let agency of service.agencyChoices|async" [value]="agency.name"
              [attr.data-agency-pk]="agency.pk">
    {{agency.name}}
  </mat-option>
</mat-autocomplete>
